export default __webpack_public_path__ + "static/media/user-placeholder.9d83d875.svg";